import requestDefault from '@/shared/utils/request';
import { IncreaseCreditInfoType, JumpInfoType, IncreaseContractType } from './types';

/**
 * @desc 获取提额专区相关信息
 * @yapi https://yapi.hellobike.cn/project/3415/interface/api/296462
 */
export const getIncreaseCreditInfo = (): Promise<IncreaseCreditInfoType> => requestDefault.postGate(
  'f.adjust.auth.info',
  {},
  {
    showLoading: undefined,
  },
);

/**
 * @desc 获取认证项协议
 */
export const getIncreaseCreditContract = (
  authId: string,
): Promise<IncreaseContractType> => requestDefault.postGate(
  'f.adjust.auth.contract.info',
  {
    authId,
  },
);

/** 订单生成，获取认证跳转信息
 * @authId 提额项 ID
 * @yapi https://yapi.hellobike.cn/project/3415/interface/api/296470
 */
export const getJumpInfo = (
  authId: string,
): Promise<JumpInfoType> => requestDefault.postGate(
  'f.auth.apply.order',
  {
    authId,
    screenWidth: document.documentElement.clientWidth,
    screenHeight: document.documentElement.clientHeight,
  },
);
